import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Package, Plus, X } from 'lucide-react';

import s from './AddonsManager.css';
import messages from '../../../locale/messages';

class AddonsManager extends Component {
    static propTypes = {
        listId: PropTypes.number.isRequired,
        addons: PropTypes.array,
        onChange: PropTypes.func.isRequired,
        currency: PropTypes.string,
    };

    static defaultProps = {
        addons: [],
        currency: 'USD',
    };

    handleAddRow = () => {
        const { addons, onChange } = this.props;
        const newAddon = {
            tempId: Date.now(),
            name: '',
            description: '',
            price: '',
            priceType: 'per_booking',
        };
        onChange([...addons, newAddon]);
    };

    handleRemoveRow = (index) => {
        const { addons, onChange } = this.props;
        const updated = addons.filter((_, i) => i !== index);
        onChange(updated);
    };

    handleFieldChange = (index, field, value) => {
        const { addons, onChange } = this.props;
        const updated = addons.map((addon, i) => {
            if (i === index) {
                return { ...addon, [field]: value };
            }
            return addon;
        });
        onChange(updated);
    };

    render() {
        const { addons, currency } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className={s.addonsSection}>
                <div className={s.sectionTitle}>
                    <Package className={s.sectionIcon} />
                    <span><FormattedMessage {...messages.addons} /></span>
                </div>

                {addons.length > 0 && (
                    <div className={s.labelRow}>
                        <span><FormattedMessage {...messages.addonName} /></span>
                        <span><FormattedMessage {...messages.addonDescription} /></span>
                        <span><FormattedMessage {...messages.addonPrice} /></span>
                        <span><FormattedMessage {...messages.priceType} /></span>
                        <span></span>
                    </div>
                )}

                {addons.map((addon, index) => (
                    <div key={addon.id || addon.tempId} className={s.addonRow}>
                        <input
                            type="text"
                            className={s.addonInput}
                            placeholder={formatMessage(messages.addonName)}
                            value={addon.name || ''}
                            onChange={(e) => this.handleFieldChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            className={s.addonInput}
                            placeholder={formatMessage(messages.addonDescription)}
                            value={addon.description || ''}
                            onChange={(e) => this.handleFieldChange(index, 'description', e.target.value)}
                        />
                        <div className={s.priceInputWrapper}>
                            <span className={s.currencySymbol}>{currency}</span>
                            <input
                                type="number"
                                className={`${s.addonInput} ${s.priceInput}`}
                                placeholder="0"
                                min="0"
                                step="0.01"
                                value={addon.price || ''}
                                onChange={(e) => this.handleFieldChange(index, 'price', e.target.value)}
                            />
                        </div>
                        <select
                            className={s.addonSelect}
                            value={addon.priceType || 'per_booking'}
                            onChange={(e) => this.handleFieldChange(index, 'priceType', e.target.value)}
                        >
                            <option value="per_booking">{formatMessage(messages.perBooking)}</option>
                            <option value="per_person">{formatMessage(messages.perPerson)}</option>
                        </select>
                        <button
                            type="button"
                            className={s.removeBtn}
                            onClick={() => this.handleRemoveRow(index)}
                            title={formatMessage(messages.remove)}
                        >
                            <X size={16} />
                        </button>
                    </div>
                ))}

                {addons.length === 0 && (
                    <div className={s.emptyState}>
                        <FormattedMessage {...messages.noAddonsYet} />
                    </div>
                )}

                <button
                    type="button"
                    className={s.addButton}
                    onClick={this.handleAddRow}
                >
                    <Plus size={16} />
                    <FormattedMessage {...messages.addAddon} />
                </button>
            </div>
        );
    }
}

const mapState = (state) => ({
    currency: state?.currency?.base || 'USD',
});

export default injectIntl(withStyles(s)(connect(mapState)(AddonsManager)));
